// Default backstage components
import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';

// Gitlab frontend components
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';

// Mermaid
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';

// Custom CSS
import techdocsModuleCustomCss from '@internal/backstage-plugin-techdocs-module-custom-css';

// Auth imports
import {
  configApiRef,
  gitlabAuthApiRef,
  oktaAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// Entity validation
import entityValidationPlugin from '@backstage-community/plugin-entity-validation/alpha';

// Auth page configuration - conditionally render based on environment
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const environment = configApi.getString('auth.environment');

      if (environment === 'staging') {
        return (
          <SignInPage
            {...props}
            provider={{
              id: 'gitlab-auth-provider',
              title: 'GitLab',
              message: 'Sign in with GitLab',
              apiRef: gitlabAuthApiRef,
            }}
          />
        );
      }

      return (
        <SignInPage
          {...props}
          provider={{
            id: 'okta-auth-provider',
            title: 'Okta',
            message: 'Sign in with Okta',
            apiRef: oktaAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    gitlabPlugin,
    techDocsMermaidAddonModule,
    techdocsModuleCustomCss,
    entityValidationPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
